import { state } from "./state"

export const getters = {
    getContrato: state => state.contrato,
    getModalVisualizarContrato: state => state.modalVisualizarContrato,
}


export default {}